/**
 * @generated SignedSource<<c506b85e13d10127c9762fb2ddf34460>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RequestAdminPasswordResetInput = {
  app?: string | null | undefined;
  email: string;
};
export type useAuthMutationsRequestAdminPasswordResetMutation$variables = {
  input: RequestAdminPasswordResetInput;
};
export type useAuthMutationsRequestAdminPasswordResetMutation$data = {
  readonly requestAdminPasswordReset: boolean;
};
export type useAuthMutationsRequestAdminPasswordResetMutation = {
  response: useAuthMutationsRequestAdminPasswordResetMutation$data;
  variables: useAuthMutationsRequestAdminPasswordResetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "requestAdminPasswordReset",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthMutationsRequestAdminPasswordResetMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthMutationsRequestAdminPasswordResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4120c4b699f7ce2e3da15295698ee9d8",
    "id": null,
    "metadata": {},
    "name": "useAuthMutationsRequestAdminPasswordResetMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthMutationsRequestAdminPasswordResetMutation(\n  $input: RequestAdminPasswordResetInput!\n) {\n  requestAdminPasswordReset(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "afcbdc987c969f95869330dbbe74c125";

export default node;
